import { useEffect, useState } from "react";
import Header from "../../layouts/AuthLayout/header/header";
import Footer from "../home/footer";
import BreadcrumbSection from "./breadcrumb-section";
import CartSingleProduct from "./cart-single-product";
import RelatedProduct from "./related-product";
import { getProductDetails } from "./product-details-page.service";
import { useParams } from "react-router-dom";

export default function ProductDetailsPage() {
  const [productDetails, setProductDetails] = useState<any>({});
  const [loader, setLoader] = useState<boolean>(true);
  const params: any = useParams();
  useEffect(() => {
    getProductDetails(params.id).then((res) => {
      setProductDetails(res.data);
      setLoader(false);
    });
  }, []);
  return (
    <>
      {loader ? (
        <div className="loader"></div>
      ) : (
        <>
          <Header />
          <BreadcrumbSection />
          <CartSingleProduct
            title={productDetails.code}
            description={productDetails.name}
            images={productDetails.images}
            centimeter={productDetails.centimeter}
            inch={productDetails.inch}
            quantity={productDetails.quantity}
            isSample={productDetails.isSample}
            item={productDetails}
          />
          {/* <RelatedProduct /> */}
          <Footer />
        </>
      )}
    </>
  );
}
